import React, {  useEffect, useRef, useState } from 'react'
import { Col, Container, FormCheck, Row } from 'react-bootstrap'
import { AiOutlineArrowUp, AiOutlineArrowDown } from 'react-icons/ai'
import '../css/GoodNumber.css'

const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
  }

const GoodNumber = ({ value , min=undefined, max=undefined, onChange = (e) => console.log(e), isValid=undefined, isInvalid=undefined, classes='' }) => {

    const localValue=useRef(value)
    const valueRef=useRef()

    const manageInput=(value)=>{
        if(!value){
            localValue.current=null
            onChange(null)
            return
        }
        if(!isInteger(value)){
            return
        }
        const IntValue=parseInt(value)
        if(min!==undefined&&IntValue<min){
            localValue.current=min
            valueRef.current.innerText=min
            onChange(min)
            return
        }
        if(max!==undefined&&IntValue>max){
            localValue.current=max
            valueRef.current.innerText=max
            onChange(max)
            return
        }
        localValue.current=IntValue
        onChange(IntValue)
    }
    const increment=()=>{
        if(max!==undefined&&localValue.current+1>max){
            return
        } else {
            localValue.current=localValue.current+1
            valueRef.current.innerText=localValue.current
            onChange(localValue.current)
        }
    }
    const decrement=()=>{
        if(min!==undefined&&localValue.current-1<min){
            return
        } else {
            localValue.current=localValue.current-1
            valueRef.current.innerText=localValue.current
            onChange(localValue.current)
        }
    }

    useEffect(()=>{
        valueRef.current.innerText=localValue.current
    },[])
    useEffect(()=>{
        if(value!=localValue.current){
            //console.log('cambia',value)
            localValue.current=value
            valueRef.current.innerText=value
        }
    },[value])

    return (
       <div className={`number-input-container ${classes}`}>
            <div 
                ref={valueRef}
                className='number-input-value'
                contentEditable={true}
                onInput={(e)=>manageInput(e.target.innerText)}
            >
                
            </div>
            <div className='number-input-arrows'>
                <AiOutlineArrowUp className='number-input-arrow' onClick={increment} />
                <AiOutlineArrowDown className='number-input-arrow' onClick={decrement} />
            </div>
            <div className='number-input-validity'>
                
            </div>
       </div>
    )
}

export default GoodNumber